// ABOUTME: Application route definitions.
// ABOUTME: Uses React Router v7 library mode — all routes defined here, no file-based routing.
import { createBrowserRouter, Navigate } from 'react-router'
import { AppLayout } from './components/AppLayout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { LandingPage } from './pages/LandingPage'
import { HostPage } from './pages/HostPage'
import { PlayPage } from './pages/PlayPage'
import { SquarePacksPage } from './pages/SquarePacksPage'
import { SquarePackDetailPage } from './pages/SquarePackDetailPage'
import { CreateGamePage } from './pages/CreateGamePage'
import { GameManagePage } from './pages/GameManagePage'
import { ScoreCardPage } from './pages/ScoreCardPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { TermsPage } from './pages/TermsPage'
import { ContactPage } from './pages/ContactPage'
import { PricingPage } from './pages/PricingPage'
import { JoinGamePage } from './pages/JoinGamePage'
import { BillingSuccessPage } from './pages/BillingSuccessPage'

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <LandingPage /> },
      { path: '/privacy', element: <PrivacyPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/join/:id', element: <JoinGamePage /> },
      { path: '/dashboard', element: <Navigate to="/games" replace /> },
      {
        path: '/games',
        element: <ProtectedRoute><HostPage /></ProtectedRoute>,
      },
      {
        path: '/play',
        element: <ProtectedRoute><PlayPage /></ProtectedRoute>,
      },
      {
        path: '/square-packs',
        element: <ProtectedRoute><SquarePacksPage /></ProtectedRoute>,
      },
      {
        path: '/square-packs/:id',
        element: <ProtectedRoute><SquarePackDetailPage /></ProtectedRoute>,
      },
      {
        path: '/games/new',
        element: <ProtectedRoute><CreateGamePage /></ProtectedRoute>,
      },
      {
        path: '/games/:id/manage',
        element: <ProtectedRoute><GameManagePage /></ProtectedRoute>,
      },
      {
        path: '/games/:gameId/play',
        element: <ScoreCardPage />,
      },
      { path: '/billing/success', element: <BillingSuccessPage /> },
    ],
  },
])
